import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PlatformFrontendFormErrorStatesEnum {
    CreatePlatformFrontendFailed = ErrorStateScheduleEnum.PlatformFrontendFormStatesStartIndex,
    UpdatePlatformFrontendFailed,
    DeletePlatformFrontendFailed,
    ListPlatformFrontendFailed,
    ListTradingPlatformFailed,
}
